import hasProviderAccessRights from "@/mixins/hasProviderAccessRights";

export default function registerHasProviderAccessRights(app) {
  app.mixin(hasProviderAccessRights);
}
